import { toast } from "components/ui/use-toast";

const MIME_TYPE = "application/pdf";

export const downloadPdf = (
  pdfFile: string,
  fileName: string 
) => {
  if (!pdfFile || !pdfFile.startsWith(`data:${MIME_TYPE};base64,`)) {
    toast({
      description: "Nenhum arquivo PDF disponível para download.",
      variant: "destructive",
    });
    return;
  }

  try {
    const base64Data = pdfFile.split(",")[1];
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(0)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: MIME_TYPE });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    toast({
      description: "Arquivo PDF gerado com sucesso!",
      variant: "default",
    });
  } catch (error) {
    toast({
      description: "Erro ao processar o arquivo PDF.",
      variant: "destructive",
    });
    console.error("Erro ao converter Base64 para PDF:", error);
  }
};
